import gql from 'graphql-tag';

export default gql`
    mutation DeleteAssetLoads($input: DeleteAssetLoadsInput) {
        deleteAssetLoads(input: $input) {
            errors
        }
    }
`;
